import { InventoryDTO } from "../DTO/inventoryDTO";

export class DeleteInventoryRequest{
    public userId!:string;
    public businessId!:string;
    public inventory!:InventoryDTO;
}